import React from 'react'

import Card from 'react-bootstrap/Card'
import Modal from 'react-bootstrap/Modal'
import CloseButton from 'react-bootstrap/CloseButton'
import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'

import { Voucher } from './Voucher'

export default function VouchersModal({ show, handleClose, flexPack }) {
  return (
    <Modal
      fullscreen="md-down"
      scrollable
      centered
      animation={false}
      show={show}
      onHide={handleClose}
    >
      <div className="header">
        <div className="header--flex">
          <Modal.Title as="h4" className="modal-body-heading-title">
            Your vouchers
          </Modal.Title>
          <CloseButton onClick={handleClose} />
        </div>
        <Card body className="card-xxs card--primary">
          <Card.Text className="info-text info-text-md info-text-primary">
            Redeem these codes during checkout for any available game, or at the
            Box Office. Use one code per ticket.
          </Card.Text>
        </Card>
      </div>
      <Modal.Body className="pb-0">
        <Stack as="ul" gap={2}>
          {flexPack?.vouchers?.map((voucher, idx) => (
            <Voucher key={idx} voucher={voucher} />
          ))}
        </Stack>
      </Modal.Body>
      <div className="btn-group-flex">
        <Button size="lg" onClick={handleClose}>
          Close
        </Button>
      </div>
    </Modal>
  )
}
